import {
  AssignableExpressionInput,
  CommonConfigComponent,
  Datatype,
  IWidgetComponentProps,
  RichTextAdvancedInput,
  StyledDrawerCollapse,
  useTreeReferencesContext,
} from '@framework/engine';
import { FormItem, MenuPresets, TextInput } from '@framework/form';
import { Collapse } from 'antd';
import { IProvinceWidget } from './IProvinceWidget';
const { Panel } = Collapse;

export interface IProvinceWidgetConfigComponentProps
  extends IWidgetComponentProps<IProvinceWidget> {}

export function ProvinceWidgetConfigComponent(
  props: IProvinceWidgetConfigComponentProps,
) {
  const { references } = useTreeReferencesContext();

  return (
    <StyledDrawerCollapse defaultActiveKey={['general']} ghost>
      <Panel header="Impostazioni Generali" key="general">
        <CommonConfigComponent
          {...props}
          hideConfigPlaceholder
          hideConfigHelpText
          hideConfigDefaultValue
          hideConfigLabel
          noConfirmation
        />
        <FormItem name="defaultProvince" label="Codice provincia di default">
          <AssignableExpressionInput
            field={{ type: Datatype.String }}
            references={references}
            name="defaultProvince"
            block
            size="large"
          />
        </FormItem>
        <FormItem name="defaultTown" label="Codice comune di default">
          <AssignableExpressionInput
            field={{ type: Datatype.String }}
            references={references}
            name="defaultTown"
            block
            size="large"
          />
        </FormItem>
      </Panel>

      <Panel header="Opzioni Provincia" key="provinceOptions">
        <FormItem name="provinceLabel" label="Etichetta provincia">
          <RichTextAdvancedInput
            name="provinceLabel"
            rows={1}
            menus={MenuPresets.Minimal}
          />
        </FormItem>

        <FormItem name="provinceHelpText" label="Testo aiuto provincia">
          <RichTextAdvancedInput
            name="provinceHelpText"
            rows={1}
            menus={MenuPresets.Minimal}
          />
        </FormItem>

        <FormItem name="provincePlaceholder" label="Placeholder provincia">
          <TextInput name="provincePlaceholder" />
        </FormItem>
      </Panel>

      <Panel header="Opzioni Comune" key="townOptions">
        <FormItem name="townLabel" label="Etichetta comune">
          <RichTextAdvancedInput
            name="townLabel"
            rows={1}
            menus={MenuPresets.Minimal}
          />
        </FormItem>

        <FormItem name="townHelpText" label="Testo aiuto comune">
          <RichTextAdvancedInput
            name="townHelpText"
            rows={1}
            menus={MenuPresets.Minimal}
          />
        </FormItem>

        <FormItem name="townPlaceholder" label="Placeholder Comune">
          <TextInput name="townPlaceholder" />
        </FormItem>
      </Panel>
    </StyledDrawerCollapse>
  );
}
